/**
 * @generated SignedSource<<a5e3b86cc31d7877d102b1b65ef265b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductBaseTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductShipping_viewer">;
  readonly " $fragmentType": "ProductBaseTile_viewer";
};
export type ProductBaseTile_viewer$key = {
  readonly " $data"?: ProductBaseTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductBaseTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductShipping_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "90e904fde8cbeaf44dd1be94332f3044";

export default node;
